import React, { useState } from 'react';
interface ImageWithFallbackProps {
  src: string;
  alt: string;
  fallbackSrc?: string;
  className?: string;
}
const ImageWithFallback = ({
  src,
  alt,
  fallbackSrc = 'https://images.unsplash.com/photo-1517697471339-4aa32003c11a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
  className
}: ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  return <img src={imgSrc} alt={alt} className={className} onError={() => {
    setImgSrc(fallbackSrc);
  }} data-id="element-468" />;
};
export default ImageWithFallback;